import { Delete } from '@mui/icons-material';
import { Box, IconButton, Button } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import TableComponent from '../../components/TableComponent';
import { showError, showToast } from '../../constants/toasts';
import MainContainer from '../../layout/MainContainer';
import { ConfirmationModal } from '../../Modals/confirmationModal';
import {
  useLazyDeleteAllReceiveNotificationQuery,
  useDeleteReceiveNotificationByIdMutation,
  useLazyGetReceiveNotificationQuery,
} from '../../service/notification';
import { ReceiveNotification } from '../../types/General';
import { PUSH_TYPE_KEYS } from '../../utils/enums';

const RecievedNotifications = () => {
  const navigate = useNavigate();
  const [notification, setNotification] = useState<ReceiveNotification[]>([]);
  const [count, setCount] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [getNotification] = useLazyGetReceiveNotificationQuery();
  const [deleteById] = useDeleteReceiveNotificationByIdMutation();
  const [deleteAll] = useLazyDeleteAllReceiveNotificationQuery();
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<string>('');
  const [deleteType, setDeleteType] = useState<'single' | 'multiple'>('multiple');
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState<boolean>(false);

  const totalPages = Math.ceil(count / 10);
  const onPageChange = (e: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const navigationFunc = (item: number | string, role: number) => {
    switch (item) {
      case PUSH_TYPE_KEYS.INSPECTION: {
        navigate(`/inspection-requests`);
        return;
      }
      // case PUSH_TYPE_KEYS.DEALER_ONBOARD: {
      //   navigate(`/listings/${USER_TYPE[role]}`);
      //   return;
      // }
      case PUSH_TYPE_KEYS.LOAN_REQUEST: {
        navigate('/financial-requests');
        return;
      }
      // case PUSH_TYPE_KEYS.USER_MARKED_AS_SOLD: {
      //   navigate(`/listings/${USER_TYPE[role]}`);
      //   return;
      // }
      default: {
        navigate('/recieved-notifications');
        return;
      }
    }
  };

  const columns: GridColDef<(typeof notification)[number]>[] = [
    {
      flex: 0.8,
      minWidth: 250,
      field: 'name',
      headerName: 'User detail',
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <Button onClick={() => navigationFunc(row?.pushType, row?.role)}>
              <figure>
                <img src={row?.user?.image || '/static/images/user_placeholder.png'} alt="User" />
              </figure>
            </Button>
            <p>
              <b>{row?.user?.name || '-'}</b> {row?.user?.dialCode} {row?.user?.phoneNo || '-'}
              <br />
              {row?.user?.email || '-'}
            </p>
          </div>
        );
      },
    },
    {
      flex: 0.6,
      minWidth: 200,
      field: 'title',
      headerName: 'Title',
      editable: false,
      sortable: false,
    },
    {
      flex: 0.6,
      minWidth: 250,
      field: 'message',
      headerName: 'Message',
      editable: false,
      sortable: false,
    },
    {
      flex: 0.4,
      minWidth: 250,
      field: 'pushType',
      headerName: 'Notification Type',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return <div className="user_block">{PUSH_TYPE_KEYS[row?.pushType] || '-'}</div>;
      },
    },
    {
      flex: 0.4,
      minWidth: 200,
      field: 'date',
      headerName: 'Date',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return <div className="user_block">{moment(row?.createdAt).format('lll') || '-'}</div>;
      },
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: 'action',
      headerName: 'Action',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                onClick={() => {
                  setDeleteType('single');
                  setOpen(true);
                  setSelectedId(row?._id);
                }}
              >
                <Delete
                  sx={{
                    color: 'red',
                    ':hover': {
                      color: 'white',
                    },
                  }}
                />
              </IconButton>
            </Box>
          </div>
        );
      },
    },
  ];

  const getNotificationList = async () => {
    setIsLoading(true);

    try {
      const body = {
        page,
        length: 10,
      };
      const res = await getNotification({
        page,
        limit: 10,
      }).unwrap();
      if (res?.statusCode === 200) {
        setNotification(res?.data?.NotificationData || []);
        setCount(res?.data?.NotificationCount);
      } else {
        setNotification([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
    }
    setIsLoading(false);
    // ref?.current?.complete();
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await deleteById({
        id: selectedId,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        showToast('Deleted successfully');
        //  setNotification(prv=>(
        //   prv.filter((item)=>(item._id!==selectedId))
        //  ))
        getNotificationList();
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      setLoading(false);
    }
  };
  const handleDeleteAll = async () => {
    setLoading(true);
    try {
      const response = await deleteAll().unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        showToast('Deleted successfully');
        // setNotification([])
        getNotificationList();
        // setNotification(prv=>(
        //  prv.filter((item)=>(item._id!==selectedId))
        // ))
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      setLoading(false);
    }
  };

  useEffect(() => {
    getNotificationList();
  }, [page]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Recieved Notifications</h1>
        <p>
          <span onClick={() => navigate('/dashboard')}>Dashboard</span> - Recieved Notifications
        </p>
      </div>

      <div className="cards">
        <div className="table_header right_top_s">
          <div className="">
            <Button
              variant="contained"
              onClick={() => {
                setDeleteType('multiple');
                setOpen(true);
              }}
            >
              Clear All
            </Button>
            {/* <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            /> */}
          </div>
        </div>
        <div className="sorting_table">
          <TableComponent
            columns={columns}
            rows={notification}
            count={count}
            page={page}
            onPageChange={onPageChange}
            loading={loading}
          />
        </div>
        {/* <TableContainer className="table_container">
          <Box className="heading"></Box>
          <Table
            sx={{ minWidth: 650 }}
            aria-label="simple table"
            className="v3"
          >
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>User Name</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Message</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {notification.length > 0 ? notification.map((item, i) => (<TableRow>
                <TableCell>{(page - 1) * 10 + (i + 1)}</TableCell>
                <TableCell>
                  <div className="user_block">
                    <figure>
                      <img src="/static/images/user_attachment.jpg" alt="" />
                    </figure>
                    <p>{item?.user?.email}</p>
                  </div>
                </TableCell>
                <TableCell>{item?.title || "-"}</TableCell>
                <TableCell className="max_c">
                  <p>
                    {item?.message || "-"}
                  </p>
                </TableCell>
                <TableCell>{moment(item?.createdAt).format('lll') || "-"}</TableCell>
                <TableCell>
                  <Box>
                    <IconButton onClick={()=>{
                      setDeleteType("single")
                      setOpen(true)
                      setSelectedId(item?._id)
                    }} >
                      <Delete sx={{
                        color: 'red'
                      }} />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>))
                : <TableRow>
                  <TableCell>No data found</TableCell>
                </TableRow>
              }
            </TableBody>
          </Table>
        </TableContainer> */}

        <ConfirmationModal
          text={
            deleteType === 'multiple'
              ? 'Are you sure to delete all recieved notification?'
              : 'Are you sure to delete this recieved notification?'
          }
          openModal={open}
          setOpenModal={setOpen}
          handleSubmit={() => {
            deleteType === 'multiple' ? handleDeleteAll() : handleDelete();
          }}
        />

        {/* <Pagination
          module={notification}
          page={page}
          onPageChange={onPageChange}
          totalPages={totalPages}
          totalCount={count}
          setPage={setPage}
        /> */}
      </div>
    </MainContainer>
  );
};

export default RecievedNotifications;
